import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'screw',
  size: 24,
  node: [
    ['path', { d: 'M10 9v10', key: 'fk50ew' }],
    ['path', { d: 'M14 13v2', key: '1x1eb0' }],
    [
      'path',
      {
        d: 'M16.5 10.5 5.706 21.294A2.4 2.4 0 014.002 22H2.5a.5.5 0 01-.5-.5v-1.502a2.4 2.4 0 01.706-1.704L13.5 7.5',
        key: '151u8u',
      },
    ],
    [
      'path',
      {
        d: 'M20.819 11.575a6 6 0 00.969-5.162.6.6 0 00-.981-.219l-.455.454a1.2 1.2 0 01-1.704 0l-1.296-1.296a1.2 1.2 0 010-1.704l.454-.453a.595.595 0 00-.219-.98 6 6 0 00-5.162.967 2 2 0 00-.222 3.019l5.596 5.597a2 2 0 003.02-.222',
        key: '6u8bap',
      },
    ],
    ['path', { d: 'M6 13v8', key: '1f4euz' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name Screw
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgOXYxMCIgLz4KICA8cGF0aCBkPSJNMTQgMTN2MiIgLz4KICA8cGF0aCBkPSJNMTYuNSAxMC41IDUuNzA2IDIxLjI5NEEyLjQgMi40IDAgMDE0LjAwMiAyMkgyLjVhLjUuNSAwIDAxLS41LS41di0xLjUwMmEyLjQgMi40IDAgMDEuNzA2LTEuNzA0TDEzLjUgNy41IiAvPgogIDxwYXRoIGQ9Ik0yMC44MTkgMTEuNTc1YTYgNiAwIDAwLjk2OS01LjE2Mi42LjYgMCAwMC0uOTgxLS4yMTlsLS40NTUuNDU0YTEuMiAxLjIgMCAwMS0xLjcwNCAwbC0xLjI5Ni0xLjI5NmExLjIgMS4yIDAgMDEwLTEuNzA0bC40NTQtLjQ1M2EuNTk1LjU5NSAwIDAwLS4yMTktLjk4IDYgNiAwIDAwLTUuMTYyLjk2NyAyIDIgMCAwMC0uMjIyIDMuMDE5bDUuNTk2IDUuNTk3YTIgMiAwIDAwMy4wMi0uMjIyIiAvPgogIDxwYXRoIGQ9Ik02IDEzdjgiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/screw
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Screw = createLucideIcon(__iconData);

export default Screw;
